export default __webpack_public_path__ + "static/media/11.3087bad4.png";